import UserAdminAccounts from "./UserAdminAccounts-container";

/**
 * Export the top level component UserAdminAccounts-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default UserAdminAccounts;
